export interface IPDPMediaItem {
  id: string;
  url: string;
  mediaType: MediaType;
  imageType?: ImageType | null;
  name: string;
  thumbnailUrl: string;
}

export enum ImageType {
  PrimaryImage = 'PRIMARY_IMAGE',
  ColourPhotograph = 'COLOUR_PHOTOGRAPH',
  VendorLogo = 'VENDOR_LOGO',
  UkEnergyLabelImage = 'UK_ENERGY_LABEL_IMAGE',
  EuEnergyLabelImage = 'EU_ENERGY_LABEL_IMAGE',
}

export enum MediaType {
  Image = 'IMAGE',
  YoutubeVideo = 'YOUTUBE_VIDEO',
  View_3D = 'VIEW_3D',
}

export interface IPDPVendorLogoMediaItem {
  url: string;
}
